import { faSearchDollar } from "@fortawesome/free-solid-svg-icons";
export const deskSelection = {
    name: "Desk Selection",
    minSize: [5, 1],
    icon: faSearchDollar,
    description: "Choose assigned desk(s)",
    defaultConfig: {
        defaultValue: null,
        key: "Desk",
    },
    type: "input",
    category: "dashboard",
};
